import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderUpsertFormComponent } from './order-upsert-form/order-upsert-form.component';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { FreightPayer } from '../../../../../shared/freight-payers/models/FreightPayer';
import { IRootState } from '../../../../app.config';
import { Store } from '@ngrx/store';
import { loadFreightPayers } from '../../../../../shared/freight-payers/freight-payer.actions';
import { selectAvailableFreightPayers } from '../../../../../shared/freight-payers/freight-payer.reducer';

@Component({
  selector: 'app-order-upsert',
  standalone: true,
  imports: [OrderUpsertFormComponent, AsyncPipe],
  templateUrl: './order-upsert.component.html',
  styleUrl: './order-upsert.component.scss'
})
export class OrderUpsertComponent implements OnInit {

  orderId: number | null = null; // This will hold the order id from the route
  freightPayers$!: Observable<FreightPayer[]>; // This will hold the freight payers

  constructor(private route: ActivatedRoute, private router: Router, private store$: Store<IRootState>) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.orderId = params['id'];
      }
    });

    this.store$.dispatch(loadFreightPayers());
    this.freightPayers$ = this.store$.select(selectAvailableFreightPayers);
  }



  returnToList() {
    this.router.navigate(['app/order/home']);
  }
}
